






import { defineComponent } from '@vue/composition-api';
import { ActionTypes } from '@/store/actions';
import { useStore } from '@/store';

export default defineComponent({
    name: 'PrintLink',
    store: useStore(),
    methods: {
        downloadPdf () {
            this.$store.dispatch(ActionTypes.DefineIsEmptyTechSpec)
                .then(() => window.print());
        }
    }
});
